<div class="host ___dashboard">

  <div class="header">
    <div class="left">
      <strong>
        <i
          class="icon-medium-tint"
          [class]="type==='record'?'icon-dashboard-record':'icon-dashboard-array'"
        ></i>
        <span>{{ type==='record' ? 'Record' : 'Array' }}</span>
      </strong>
    </div>
    <div class="right">
      <ng-container *ngIf="mode!=='edit'">
        <a
          *ngIf="currentData"
          class="view-mode"
          href="javascript:void(0)"
          (click)="mode=(mode==='table'?'raw':'table')"
        >{{ mode === 'table' ? 'Raw' : 'List' }}</a>
        <a class="edit" href="javascript:void(0)" (click)="mode='edit'">Edit</a>
      </ng-container>
      <a *ngIf="mode==='edit'" href="javascript:void(0)" (click)="mode='table'">Exit</a>
    </div>
  </div>

  <ng-container *ngIf="mode==='edit'; else viewMode">

    <div class="edit container">

      <table class="table-bordered">
        <thead>
          <tr>
            <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
            <th
              *ngFor="let schemaItem of schema"
              [class.required]="schemaItem.required"
              [style]="{'min-width': (schemaItem.width || 70) + 'px'}"
            >{{ schemaItem.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let matrixItem of dataMatrix; let i = index">
            <td><a href="javascript:void(0)" (click)="remove(i)">[-]</a></td>
            <td *ngFor="let schemaItem of matrixItem">

              <ng-container *ngIf="schemaItem.type === 'text'">
                <input class="form-control" type="text" [(ngModel)]="schemaItem.value">
              </ng-container>

              <ng-container *ngIf="schemaItem.type === 'number'">
                <input class="form-control" type="number" [(ngModel)]="schemaItem.value">
              </ng-container>

              <ng-container *ngIf="schemaItem.type === 'upload'">
                <div class="uploadable">
                  <input
                    class="form-control"
                    type="text"
                    [(ngModel)]="schemaItem.value"
                  >
                  <a
                    href="#"
                    class="button-outline-primary-sm"
                    (click)="openUploader(schemaItem, matrixItem); false;"
                  >Upload</a>
                </div>
              </ng-container>

            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="42">
              <a href="javascript:void(0)" (click)="add()">[+]</a>
            </td>
          </tr>
        </tfoot>
      </table>

    </div>

    <div class="actions">
      <div class="left">
        <a class="button-outline-dark-sm" href="javascript:void(0)" (click)="mode='table'">Cancel</a>
      </div>
      <a class="button-primary-sm" href="javascript:void(0)" (click)="submit()">Save</a>
    </div>

  </ng-container>

  <ng-template #viewMode>

    <div class="view-none" *ngIf="!currentData; else hasData">
      No value, click Edit to set.
    </div>

    <ng-template #hasData>

      <div class="view-table container" *ngIf="mode==='table'">

        <table class="table-bordered">
          <thead>
            <tr>
              <th
                *ngFor="let schemaItem of schema"
                [class.required]="schemaItem.required"
                [style]="{'min-width': (schemaItem.width || 70) + 'px'}"
              >{{ schemaItem.name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let matrixItem of dataMatrix">
              <td *ngFor="let schemaItem of matrixItem">{{ schemaItem.value }}</td>
            </tr>
          </tbody>
        </table>

      </div>
    
      <div class="view-raw container" *ngIf="mode==='raw'">
        <pre><code>{{ dataRaw }}</code></pre>
      </div>

    </ng-template>

  </ng-template>

</div>

<nguix-dashboard-uploader
  [show]="showUploader"
  [closeOnCompleted]="true"
  [imageCropping]="uploadCallerData?.imageCropping"
  (close)="showUploader=false;uploadCallerData=undefined;"
  (done)="uploadChanges($event)"
></nguix-dashboard-uploader>
